import styled from 'styled-components';
import { RoundedImage } from '../atoms/rounded-image';

export const AuthorImage = styled(RoundedImage)`
  ${({ theme }): string => theme.mixins.margin({ right: 2 })};
`;
